'use strict';

var SummaryChartAggregationFactory = function SummaryChartAggregationFactory(AbstractROMServiceAggregationFactory) {
  function SummaryChartAggregation() {
    AbstractROMServiceAggregationFactory.call(this, 'rom-summary-mode', ['summary-chart', 'cabin-thematic-chart', 'day-of-week-thematic-chart', 'days-to-departure-thematic-chart', 'point-of-sale-thematic-chart']);
  }
  SummaryChartAggregation.prototype = Object.create(AbstractROMServiceAggregationFactory.prototype);
  SummaryChartAggregation.constructor = SummaryChartAggregation;
  SummaryChartAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  SummaryChartAggregation.prototype.aggregate = function (data, metricsKeys) {
    return this.aggregateWithMetrics(data, metricsKeys);
  };
  return SummaryChartAggregation;
};
SummaryChartAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = SummaryChartAggregationFactory;